export const defaultView = "";
export default class ViewDispatcher {
    constructor(typeHierarchy) {
        this.typeHierarchy = {};
        this.views = {};
        Object.keys(typeHierarchy).forEach((child) => {
            this.typeHierarchy[child] = [...typeHierarchy[child]];
        });
    }
    lookup(type, view, originalType, originalView) {
        const typeToView = this.views[type];
        const viewComponent = typeToView && typeToView[view];
        if (viewComponent) {
            return viewComponent;
        }
        const parentTypes = this.typeHierarchy[type];
        if (!parentTypes) {
            return null;
        }
        for (const parentType of parentTypes) {
            const viewComponent = this.lookup(parentType, view, originalType, originalView); //todo breath first search
            if (viewComponent) {
                return viewComponent;
            }
        }
        return null;
    }
    lookupView(type, view, viewType) {
        if (viewType) {
            const viewWithViewType = view + "[" + viewType + "]";
            const viewComponent = this.lookup(type, viewWithViewType, type, viewWithViewType);
            return viewComponent || this.lookup(type, view, type, viewWithViewType);
        }
        return this.lookup(type, view, type, view);
    }
    addViewComponent(viewComponent, type, view = defaultView) {
        this.views[type] = this.views[type] || {};
        this.views[type][view] = viewComponent;
    }
}
//# sourceMappingURL=index.js.map